import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M11 10.19L8 13l-3-2.81.857-.803 1.538 1.44L7.394 3h1.212v7.827l1.537-1.44.857.803z"
      ></path>
    </svg>
  )
}

export default Icon
